module.exports = __webpack_public_path__ + "img/13.22720439.jpg";